import { createStreamEpic } from '../../../signalr/createStreamEpic'
import { fetchActivityTickerDefinition } from './definition'

export default createStreamEpic(
  'activityticker.fetch',
  fetchActivityTickerDefinition
)
